<!-- ── Feedback rating modal (opened from the user menu via FeedbackUiService) ── -->
<div class="overlay" *ngIf="open" (click)="closeModal()">
  <div class="modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="fb-title">

    <button class="modal__close" type="button" (click)="closeModal()" aria-label="Close">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </button>

    <!-- ══ Step 1: survey ════════════════════════════════════════════════════ -->
    <ng-container *ngIf="!submitted">
      <!-- Header -->
      <div class="header">
        <span class="brand">
          <span class="brand__badge" aria-hidden="true">
            <svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M1.5 1l6 3.5-6 3.5z" fill="#fff"/></svg>
          </span>
          Planning Suite
        </span>
      </div>

      <h3 class="modal__title" id="fb-title">Share your feedback</h3>
      <p class="modal__sub">Rate your experience across a few areas. It takes under a minute.</p>

      <!-- Completion progress bar -->
      <div class="progress" role="progressbar"
           [attr.aria-valuenow]="ratedCount" aria-valuemin="0" [attr.aria-valuemax]="requiredCount">
        <div class="progress__fill" [style.width.%]="progressPct"></div>
      </div>

      <div class="fb-scroll">
        <!-- Questions -->
        <div class="question" *ngFor="let q of questions" [class.question--done]="isAnswered(q)">
          <p class="question__text">
            <span class="question__check" [class.question__check--done]="isAnswered(q)" aria-hidden="true">
              <svg *ngIf="isAnswered(q)" width="18" height="18" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" fill="#329989"/>
                <path d="M6 10.5l3 3 5-5.5" stroke="#fff" stroke-width="1.9"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span>{{ q.text }}<em class="question__opt" *ngIf="!q.required"> (optional)</em></span>
          </p>

          <!-- Answer control, by question type -->
          <ng-container [ngSwitch]="q.type">

            <!-- Scale 1–5 -->
            <div class="scale-row" *ngSwitchCase="'scale'">
              <span class="anchor">{{ q.low }}</span>
              <div class="scale" role="radiogroup" [attr.aria-label]="q.text">
                <button
                  *ngFor="let v of scale"
                  type="button"
                  class="dot"
                  [class.dot--selected]="answers[q.id] === v"
                  [attr.aria-pressed]="answers[q.id] === v"
                  (click)="selectScale(q.id, v)">
                  {{ v }}
                </button>
              </div>
              <span class="anchor">{{ q.high }}</span>
            </div>

            <!-- Yes / No -->
            <div class="pill-row" *ngSwitchCase="'boolean'" role="radiogroup" [attr.aria-label]="q.text">
              <button
                type="button"
                class="pill"
                [class.pill--selected]="answers[q.id] === true"
                [attr.aria-pressed]="answers[q.id] === true"
                (click)="selectBoolean(q.id, true)">
                Yes
              </button>
              <button
                type="button"
                class="pill"
                [class.pill--selected]="answers[q.id] === false"
                [attr.aria-pressed]="answers[q.id] === false"
                (click)="selectBoolean(q.id, false)">
                No
              </button>
            </div>

            <!-- Free text -->
            <div class="text-row" *ngSwitchCase="'text'">
              <input
                type="text"
                class="text-input"
                [attr.aria-label]="q.text"
                [ngModel]="answers[q.id]"
                (ngModelChange)="answers[q.id] = $event; onTextChange()"
                placeholder="Type your answer…" />
            </div>

          </ng-container>
        </div>

        <!-- Comment -->
        <div class="comment">
          <textarea
            rows="3"
            [(ngModel)]="comment"
            placeholder="Anything else you'd like to share? (optional)"></textarea>
        </div>

        <!-- Error banner -->
        <div class="error-banner" *ngIf="error">{{ error }}</div>
      </div>

      <!-- Footer -->
      <div class="footer">
        <span class="progress-note"><b>{{ ratedCount }}</b> of {{ requiredCount }} answered</span>
        <button
          class="btn-primary"
          type="button"
          [disabled]="!allRated || submitting"
          (click)="submit()">
          <span *ngIf="!submitting">Submit Feedback</span>
          <span *ngIf="submitting">Submitting…</span>
        </button>
      </div>
    </ng-container>

    <!-- ══ Step 2: thank-you ═════════════════════════════════════════════════ -->
    <div class="thanks" *ngIf="submitted">
      <span class="thanks__check" aria-hidden="true">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
          <path d="M6 13.5l4.5 4.5L20 8" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <h3 class="thanks__title">Thanks for your feedback!</h3>
      <p class="thanks__text">Your response has been recorded.</p>
      <p class="thanks__text">Would you like to help us improve Planning Suite even further?</p>

      <div class="thanks__actions">
        <a class="btn-share" [href]="detailedFeedbackUrl" target="_blank" rel="noopener noreferrer">
          Share Detailed Feedback
        </a>
        <button class="btn-close" type="button" (click)="closeModal()">Close</button>
      </div>
    </div>

  </div>
</div>
